import type { ReactNode } from 'react'

type PageToolbarProps = {
  children?: ReactNode
  left?: ReactNode
  right?: ReactNode
}

/**
 * Filter / view toolbar under PageHeader.
 */
export function PageToolbar({ children, left, right }: PageToolbarProps) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2 rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-2 shadow-[var(--shadow-level-1)]">
      {left ? <div className="flex flex-wrap items-center gap-2">{left}</div> : null}
      {children}
      {right ? (
        <div className="flex flex-wrap items-center gap-2 sm:ml-auto">{right}</div>
      ) : null}
    </div>
  )
}
